import { Navigate, Route, Routes } from "react-router-dom";
import { DashboardLayout } from "./components/DashboardLayout";
import { AccountsPage } from "./pages/AccountsPage";
import { CategoriesPage } from "./pages/CategoriesPage";
import { OverviewPage } from "./pages/OverviewPage";
import { LoginPage } from "./pages/LoginPage";
import { ResetPasswordPage } from "./pages/ResetPasswordPage";
import { SignupPage } from "./pages/SignupPage";
import { TransactionsPage } from "./pages/TransactionsPage";
import { TransfersPage } from "./pages/TransfersPage";
import { ReportsPage } from "./pages/ReportsPage";
import { AssistantPage } from "./pages/AssistantPage";
import { AdminPage } from "./pages/AdminPage";
import { useAuth } from "./SessionContext";
import { OfflineNotice } from "./components/OfflineNotice";

export function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="layout">
        <OfflineNotice />
        <p className="muted">Loading…</p>
      </div>
    );
  }

  return (
    <>
      <OfflineNotice />
      <Routes>
        <Route path="/login" element={user ? <Navigate to="/" replace /> : <LoginPage />} />
        <Route path="/signup" element={user ? <Navigate to="/" replace /> : <SignupPage />} />
        <Route path="/reset-password" element={<ResetPasswordPage />} />
        <Route path="/" element={user ? <DashboardLayout /> : <Navigate to="/login" replace />}>
          <Route index element={<OverviewPage />} />
          <Route path="accounts" element={<AccountsPage />} />
          <Route path="categories" element={<CategoriesPage />} />
          <Route path="transactions" element={<TransactionsPage />} />
          <Route path="transfers" element={<TransfersPage />} />
          <Route path="reports" element={<ReportsPage />} />
          <Route path="assistant" element={<AssistantPage />} />
          <Route path="admin" element={<AdminPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}
